import apiDtMood from './dtMoodApiHandler'

const sendfeelings = (data) => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .post('/feelings/', data)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const getFeelings = () => {
  return new Promise((resolve, reject) => {
    apiDtMood
      .get('/feeling-types/')
      .then((res) => {
        const data = res.data.map((item) => {
          item.selected = false
          return item
        })
        resolve(data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getFeelings, sendfeelings }
